import React, { useState } from 'react';
import { Form } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';

// Shared UI Library Components
import {
  CustomButton,
  defaultValidateMessages,
  DiscardModal,
  InputPassword,
  passwordPattern,
  CustomPhoneNumber,
  PasswordValidationTooltip
} from '@ppmcore/seven-ppm-core-shared-components-react';

// Components
import { AuthLayout } from '../auth-modules/auth-layout/auth-layout';

// Thunks
import { clearAuthState, signUpUser } from '../../../store/auth/auth.thunks';

// Interfaces
import { IAuthData } from '../../../interfaces/auth.interfaces';

// Styles
import './sign-up-confirm.scss';

export const SignUpConfirm = () => {
  console.log('CustomPhoneNumber.defaultProps', CustomPhoneNumber)
  const [confirmForm] = Form.useForm();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const [btnDisabled, setBtnDisabled] = useState(true);
  const [discardModalOpen, setDiscardModalOpen] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [formattedPhone, setFormattedPhone] = useState('');
  const [isPhoneValueValid, setIsPhoneValueValid] = useState<boolean>(true);

  const onCancel = (value: boolean) => {
    if (value) {
      confirmForm.resetFields();
      dispatch(clearAuthState());
      localStorage.clear();
      navigate('/sign-up');
    }
    setDiscardModalOpen(false);
  }

  const checkFormValid = (value: boolean) => {
    const { password, password_confirmation } = confirmForm.getFieldsValue();
    setIsPhoneValueValid(value);

    if (password !== undefined
      && password_confirmation !== undefined
      && password !== ''
      && password_confirmation !== ''
      && new RegExp(passwordPattern).test(password)
      && password_confirmation === password
      && value) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }

  const onValuesChange = (changedValues: { password: string } | { password_confirmation: string },
                          allFormValues: { password: string | undefined, password_confirmation: string | undefined }) => {
    if (allFormValues.password !== undefined
      && allFormValues.password_confirmation !== undefined
      && allFormValues.password !== ''
      && allFormValues.password_confirmation !== ''
      && new RegExp(passwordPattern).test(allFormValues.password)
      && allFormValues.password_confirmation === allFormValues.password
      && isPhoneValueValid) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  };

  const onFinish = () => {
    confirmForm.validateFields().then((values) => {
      const {password, password_confirmation} = values;
      const userData = localStorage.getItem('signUp');
      if (userData) {
        const userDataParsed = JSON.parse(userData);
        dispatch(signUpUser({
          first_name: userDataParsed.first_name,
          last_name: userDataParsed.last_name,
          email: userDataParsed.email,
          phone: formattedPhone,
          password, password_confirmation
        })).then((res: {payload: IAuthData}) => {
          if (res.payload) {
            localStorage.setItem('temporaryToken', res.payload.temporary_token);
            localStorage.setItem('authVerificationResendAccess', res.payload?.resend_access);
            navigate('/account-verification');
          }
        });
      }
    }).catch((error) => {
      console.error('Form validation failed', error);
    });
  };

  return (<AuthLayout cardTitle="Sign Up" cardCurrentStep={'2'} cardTotalSteps={'2'}>
    <Form
      form={confirmForm}
      className="sign-up-confirm-password"
      name="sign-up-confirm-password"
      onFinish={onFinish}
      onValuesChange={onValuesChange}
      autoComplete="off"
      validateMessages={defaultValidateMessages}>

      <Form.Item>
        <CustomPhoneNumber
          PhoneInput={ PhoneInput }
          isPhoneNumberValid={(value) => {
            checkFormValid(value);
          }}
          onChangeFormattedPhone={(value) => {
            setFormattedPhone(value);
          }} />
      </Form.Item>

      <Form.Item
        name="password"
        dependencies={['password_confirmation']}
        messageVariables={{fieldLabel: 'Password'}}
        rules={[
          {required: true},
          ({getFieldValue}) => ({
            validator(_, value) {
              if (!value || new RegExp(passwordPattern).test(getFieldValue('password'))) {
                setShowPasswordError(false);
                return Promise.resolve();
              }
              setShowPasswordError(true);
              return Promise.reject(new Error());
            }
          })
        ]}>
        <div>
          {showPasswordError && <PasswordValidationTooltip/>}
          <InputPassword placeholder={'Password*'}/>
        </div>
      </Form.Item>

      <Form.Item
        name="password_confirmation"
        dependencies={['password']}
        messageVariables={{fieldLabel: 'Confirm Password'}}
        rules={[
          {required: true},
          ({getFieldValue}) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error(defaultValidateMessages.passwordsDontMatch));
            }
          })]}>
        <InputPassword placeholder={'Confirm Password*'}/>
      </Form.Item>

      <div className="form-bottom">
        <CustomButton text="Cancel" type={'text'} onClick={() => setDiscardModalOpen(true)}/>
        <CustomButton htmlType={'submit'} disabled={btnDisabled} text="Sign Up"/>
      </div>
    </Form>

    <DiscardModal open={discardModalOpen}
                  onCancel={(value) => onCancel(value)}
                  title={'Are you sure you want to discard your Sign Up?'} />
  </AuthLayout>);
}
